import React from "react";
import {
  TopToolbar,
  FilterButton,
  ExportButton,
  CreateButton,
  Button,
} from "react-admin";

import { CloudUpload } from "@material-ui/icons";

export const MyListActions = (props) => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportButton />
    <Button
      onClick={() => {
        alert("Not yet implemented");
      }}
      label="Upload"
    >
      <CloudUpload />
    </Button>
  </TopToolbar>
);
